(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  if(!window.plSearchFocusBound){
  window.plSearchFocusBound=true;

  document.addEventListener('pointerdown',function(e){
    const input=e.target.closest('.search-modal .field__input');

    document
      .querySelectorAll('.search-modal .field.pl-user-focus')
      .forEach(field=>field.classList.remove('pl-user-focus'));

    if(input){
      input.closest('.field').classList.add('pl-user-focus');
    }
  });

  document.addEventListener('input',function(e){
    if(e.target.matches('.search-modal .field__input')){
      e.target.closest('.field').classList.add('pl-user-focus');
    }
  });

  document.addEventListener('focusout',function(e){
    if(e.target.matches('.search-modal .field__input')){
      e.target.closest('.field').classList.remove('pl-user-focus');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-category-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pl-category-carousel')) {
    customElements.define('pl-category-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.viewport = this.querySelector('.pl-category-carousel__viewport');
        this.cards = Array.from(this.querySelectorAll('.pl-category-carousel__item'));
        this.previous = this.querySelector('[data-category-previous]');
        this.next = this.querySelector('[data-category-next]');
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.viewport.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.viewport.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') this.move(event.key === 'ArrowLeft' ? -1 : 1);
          else this.scrollTo(event.key === 'Home' ? 0 : this.maximum());
        }, options);
        this.viewport.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.drag = { id: event.pointerId, x: event.clientX, left: this.viewport.scrollLeft };
          this.dragged = false;
        }, options);
        this.viewport.addEventListener('pointermove', event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          if (event.buttons === 0) {
            this.drag = null;
            this.viewport.dataset.dragging = 'false';
            return;
          }
          const distance = event.clientX - this.drag.x;
          if (!this.dragged && Math.abs(distance) < 8) return;
          if (!this.dragged) {
            this.dragged = true;
            this.viewport.dataset.dragging = 'true';
            this.viewport.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          this.viewport.scrollLeft = this.drag.left - distance;
        }, options);
        const endDrag = event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const destination = Math.min(Math.round(this.viewport.scrollLeft / this.step()) * this.step(), this.maximum());
          if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
          this.drag = null;
          this.viewport.dataset.dragging = 'false';
          if (this.dragged) this.scrollTo(destination);
          if (event.type === 'pointercancel') this.dragged = false;
          this.update();
        };
        this.viewport.addEventListener('pointerup', endDrag, options);
        this.viewport.addEventListener('pointercancel', endDrag, options);
        this.viewport.addEventListener('pointerleave', () => {
          if (!this.dragged) this.drag = null;
        }, options);
        this.viewport.addEventListener('click', event => {
          if (this.dragged) {
            event.preventDefault();
            event.stopPropagation();
            this.dragged = false;
          }
        }, { ...options, capture: true });
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.categoryBlock === event.detail.blockId);
          if (card) this.scrollTo(card.offsetLeft - this.cards[0].offsetLeft);
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.viewport);
        this.update();
      }
      maximum() { return Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth); }
      scrollTo(left) {
        this.viewport.scrollTo({ left: Math.max(0, Math.min(left, this.maximum())), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      move(direction) {
        if (this.cards.length) this.scrollTo(this.viewport.scrollLeft + this.step() * direction);
      }
      step() { return (this.cards[0]?.offsetWidth || 0) + (parseFloat(getComputedStyle(this.querySelector('.pl-category-carousel__track')).gap) || 0); }
      update() {
        this.previous.disabled = this.viewport.scrollLeft <= 2;
        this.next.disabled = this.viewport.scrollLeft >= this.maximum() - 2;
      }
      disconnectedCallback() {
        this.events?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
